// src/AdminStudents.js
import { useEffect, useState } from "react";
import { ref, uploadBytes, deleteObject } from "firebase/storage";
import { db, functions, storage } from "./firebase";
import {
  collection,
  addDoc,
  doc,
  setDoc,
  onSnapshot,
  query,
  orderBy,
  deleteDoc,
} from "firebase/firestore";


function AdminStudents() {
  const [students, setStudents] = useState([]);

  // Formularzustand
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [matricNumber, setMatricNumber] = useState("");
  const [validFrom, setValidFrom] = useState("");
  const [validTo, setValidTo] = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [photoFile, setPhotoFile] = useState(null);

  // Studierende aus Firestore laden
useEffect(() => {
  const colRef = collection(db, "students");

  const unsub = onSnapshot(
    colRef,
    (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // NEU: nach Nachname, dann Vorname sortieren
      list.sort((a, b) => {
        const nameA = `${a.lastName || ""} ${a.firstName || ""}`.toLowerCase();
        const nameB = `${b.lastName || ""} ${b.firstName || ""}`.toLowerCase();
        return nameA.localeCompare(nameB, "de");
      });

      setStudents(list);
    },
    (error) => {
      console.error("Fehler beim Lesen der Studierenden:", error);
    }
  );

  return () => unsub();
}, []);



// neuen Studenten anlegen
const handleCreateStudent = async (e) => {
  e.preventDefault();
  setMessage("");

  if (
    !firstName ||
    !lastName ||
    !birthDate ||
    !matricNumber ||
    !validFrom ||
    !validTo
  ) {
    setMessage("Bitte alle Felder ausfüllen.");
    return;
  }

  try {
    // eigene Dokument-ID erzeugen
    const docRef = doc(collection(db, "students"));

    // Standard: kein Foto
    let photoPath = null;

    // Wenn ein Bild ausgewählt wurde → in Storage hochladen
    if (photoFile) {
      const storageRef = ref(
        storage,
        `studentPhotos/${docRef.id}_${photoFile.name}`
      );
      await uploadBytes(storageRef, photoFile);
      photoPath = storageRef.fullPath; // z.B. "studentPhotos/abc123_meinfoto.jpg"
    }

    // Student-Dokument speichern (inkl. optionalem Foto-Pfad)
    await setDoc(docRef, {
      firstName,
      lastName,
      birthDate,
      matricNumber,
      validFrom,
      validTo,
      photoPath, // wird später in der Function benutzt
    });

    // Formular zurücksetzen
    setFirstName("");
    setLastName("");
    setBirthDate("");
    setMatricNumber("");
    setValidFrom("");
    setValidTo("");
    setPhotoFile(null);
    setMessage("Student wurde gespeichert.");
  } catch (err) {
    console.error(err);
    setMessage("Fehler beim Speichern.");
  }
};


 
  // Pass erzeugen
const handleGeneratePass = async (studentId) => {
  setLoading(true);
  setMessage("");

  try {
    const response = await fetch(
      "https://us-central1-studentenausweisapp.cloudfunctions.net/generateStudentPassHttp",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ studentId }),
      }
    );

    if (!response.ok) {
      const text = await response.text();
      console.error("Fehler vom Server:", text);
      setMessage("Fehler beim Erzeugen des Passes.");
      setLoading(false);
      return;
    }

    const data = await response.json();
    const { file, fileName } = data;

    // Base64 in Blob umwandeln
    const byteChars = atob(file);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: "application/vnd.apple.pkpass",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    setMessage("Pass wurde erzeugt. Auf dem iPhone in Wallet öffnen.");
  } catch (err) {
    console.error(err);
    setMessage("Fehler beim Erzeugen des Passes (Netzwerk).");
  } finally {
    setLoading(false);
  }
};


const handleGenerateGoogleWallet = async (studentId) => {
  setLoading(true);
  setMessage("");

  try {
const response = await fetch(
  "https://us-central1-studentenausweisapp.cloudfunctions.net/generateStudentGoogleWalletUrl",
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ studentId }),
  }
);

if (!response.ok) {
  const text = await response.text();
  console.error("Serverfehler:", text);
  setMessage("Fehler beim Erzeugen der Google-Wallet-Karte (Server).");
  return;
}

const data = await response.json();


    if (data.url) {
      window.open(data.url, "_blank");
      setMessage("Google-Wallet-Karte kann jetzt hinzugefügt werden.");
    } else {
      setMessage("Keine Google-Wallet-URL erhalten.");
    }
  } catch (err) {
    console.error(err);
    setMessage("Fehler beim Erzeugen der Google-Wallet-Karte.");
  } finally {
    setLoading(false);
  }
};



const handleDeleteStudent = async (student) => {
  if (!window.confirm("Diesen Studenten und sein Foto wirklich löschen?")) {
    return;
  }

  setLoading(true);
  setMessage("");

  try {
    // 1. Foto aus Storage löschen (falls vorhanden)
    if (student.photoPath) {
      const fileRef = ref(storage, student.photoPath);
      await deleteObject(fileRef);
    }

    // 2. Firestore-Dokument löschen
    await deleteDoc(doc(db, "students", student.id));

    setMessage("Student wurde gelöscht.");
  } catch (err) {
    console.error("Fehler beim Löschen:", err);
    setMessage("Fehler beim Löschen.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container my-4">
      <h2 className="mb-4">Studierendenausweise</h2>

      {/* Formular neuer Student */}
      <div className="card mb-4">
        <div className="card-header">Neuen Studenten anlegen</div>
        <div className="card-body">
          <form onSubmit={handleCreateStudent}>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Vorname</label>
                <input
                  className="form-control"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="col">
                <label className="form-label">Nachname</label>
                <input
                  className="form-control"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">
                  Geburtsdatum (z.B. 01.01.2000)
                </label>
                <input
                  className="form-control"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                />
              </div>
              <div className="col">
                <label className="form-label">Matrikelnummer</label>
                <input
                  className="form-control"
                  value={matricNumber}
                  onChange={(e) => setMatricNumber(e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Gültig von</label>
                <input
                  className="form-control"
                  value={validFrom}
                  onChange={(e) => setValidFrom(e.target.value)}
                  placeholder="01.10.2025"
                />
              </div>
              <div className="col">
                <label className="form-label">Gültig bis</label>
                <input
                  className="form-control"
                  value={validTo}
                  onChange={(e) => setValidTo(e.target.value)}
                  placeholder="30.09.2026"
                />
              </div>
            </div>
<div className="mb-3">
  <label className="form-label">Passfoto (JPEG/PNG)</label>
  <input
    type="file"
    accept="image/*"
    className="form-control"
    onChange={(e) => {
      const file = e.target.files?.[0];
      setPhotoFile(file || null);
    }}
  />
</div>


            <button type="submit" className="btn btn-primary">
              Student speichern
            </button>
          </form>
        </div>
      </div>

      {/* Meldungen */}
      {message && (
        <div className="alert alert-info" role="alert">
          {message}
        </div>
      )}

      {/* Liste der Studierenden */}
      <div className="card">
        <div className="card-header">Studierende</div>
        <div className="card-body">
          {students.length === 0 ? (
            <p>Noch keine Studierenden angelegt.</p>
          ) : (
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Matrikelnummer</th>
                  <th>Gültigkeit</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
                {students.map((s) => (
                  <tr key={s.id}>
                    <td>
                      {s.lastName}, {s.firstName}
                    </td>
                    <td>{s.matricNumber}</td>
                    <td>
                      {s.validFrom} – {s.validTo}
                    </td>
                    <td>
  <button
    className="btn btn-outline-primary btn-sm me-2"
    onClick={() => handleGeneratePass(s.id)}
    disabled={loading}
  >
    Pass erstellen
  </button>
  <button
    className="btn btn-outline-danger btn-sm"
    onClick={() => handleDeleteStudent(s)}
    disabled={loading}
  >
    Löschen
  </button>
  <button
  className="btn btn-outline-success btn-sm"
  onClick={() => handleGenerateGoogleWallet(s.id)}
  disabled={loading}
>
  In Google Wallet speichern
</button>
</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminStudents;
